import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static values = {
    notifications: Array,
  }

  connect() {
    this.notificationsValue.forEach(({ type, message, title }) => {
      toastr[type](message, title, { closeButton: true });
    });
  }
}
